import React from 'react';
import { useState, useEffect } from 'react';
import { Button, ButtonGroup, Card, CardBody, CardFooter, Col, Row, CardHeader, FormGroup, Input, Label, Modal } from 'reactstrap';
import {Typeahead, asyncContainer} from 'react-bootstrap-typeahead'; 
import 'react-bootstrap-typeahead/css/Typeahead.css';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import 'moment/locale/es'

import { customStyles } from '../../utils/customStyle';
import { getAction, deleteAction, upAction } from '../../utils/ApiHandler';
import Loader     from "react-spinners/MoonLoader";
import { css }    from "@emotion/core";
const override = css`
  display: block;
  position: fixed;
  margin: 0 auto;
  z-index: 9999;
  left: 50%;
  top: 25%;
  border-color: red;
`;


moment.locale('es')
const AsyncTypeahead = asyncContainer(Typeahead);

const Dashboard = () => {
    const [tabla_clientes,            setClientes]            = useState([]);
    const [getSelectedCliente,        setSelectedCliente]     = useState([]);

    const [tabla_Multimedios,         setTablaMultimedios]    = useState([]);

    const [getCI_pdf,                 setCI_pdf]              = useState('');
    const [getEscritura_pdf,          setEscritura_pdf]       = useState('');
    const [getAutorizacio_pdf,        setAutorizacio_pdf]     = useState('');
    const [getPlanoPropiedad_pdf,     setPlanoPropiedad_pdf]  = useState('');
    const [getPlanoVivienda_pdf,      setPlanoVivienda_pdf]   = useState('');
    const [getPresupuesto,            setPresupuesto]         = useState('');
    const [getThumbs,                 setThumbs]              = useState('');

    const [getShowRut,                setShowRut]             = useState(false);
    const [getShowEscritura,          setShowEscritura]       = useState(false);
    const [getShowAutorizacion,       setShowAutorizacion]    = useState(false);
    const [getShowSubdividida,        setShowSubdividida]     = useState(false);
    const [getShowVivienda,           setShowVivienda]        = useState(false);
    const [getShowPresupuesto,        setShowPresupuesto]     = useState(false);

    const [getId,                     setId]                  = useState('');
    const [getFactibilidad,           setFactibilidad]        = useState('');
    const [getNomFile,                setNomFile]             = useState('');
    const [getFile,                   setFile]                = useState('');

    const [modalpdf,                  setModalpdf]            = useState(false);
    const [modalpdfTitle,             setModalpdfTitle]       = useState('');  

    const [modal,                     setModal]               = useState(false);
    const [modalTitle,                setModalTitle]          = useState('');

    const empresa_id = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).empresa_id : ''
    const [getGifLoader,          setGifLoader]    = useState(false);
    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };


  useEffect(() => {
        getCustomers();
  }, []);
  const getCustomers = async (query) => {
    try {
      setGifLoader(true)
      const res = await getAction('/api/basicCustomer/'+ empresa_id + '/'+ query)
      if (!res.ok) {
        throw Error(res.statusText);
      }
      res.json() 
      .then((resp => {
          var data = resp.data
          data.sort((a, b) => a.nombre - b.nombre)
          setClientes(data)
          setGifLoader(false)
        })
      )
    }
    catch (err) {
      setGifLoader(false)
      toast.error(<span><i className="fa fa-minus-circle"></i> Error al intentar obtener la lista de Clientes!</span>, {position: toast.POSITION.TOP_RIGHT})
    }
  }

//Consulta
  const getMultimedios = async () => {
    if (getSelectedCliente.length === 0){
      toast.warning(<span><i className="fa fa-minus-circle"></i>  Debe seleccionar un cliente.</span>, {position: toast.POSITION.TOP_RIGHT})
      return false
    }
    setGifLoader(true)
    try{
      const res = await getAction('/api/customerAdjuntos/'+ getSelectedCliente[0].id)
      if (!res.ok) {
          throw Error(res.statusText);
      }  
      res.json()
      .then((resp => {
            setCI_pdf(resp.data.adjunto_rut)
            setEscritura_pdf(resp.data.adjunto_escritura)
            setAutorizacio_pdf(resp.data.adjunto_autorizacion)
            setPlanoPropiedad_pdf(resp.data.adjunto_plano_subdividida)
            setPlanoVivienda_pdf(resp.data.adjunto_plano_vivienda)
            setPresupuesto(resp.data.adjunto_presupuesto)

            resp.data.adjunto_rut               !== null ? setShowRut(true)          : setShowRut(false);
            resp.data.adjunto_escritura         !== null ? setShowEscritura(true)    : setShowEscritura(false);
            resp.data.adjunto_autorizacion      !== null ? setShowAutorizacion(true) : setShowAutorizacion(false);
            resp.data.adjunto_plano_subdividida !== null ? setShowSubdividida(true)  : setShowSubdividida(false);
            resp.data.adjunto_plano_vivienda    !== null ? setShowVivienda(true)     : setShowVivienda(false);
            resp.data.adjunto_presupuesto       !== null ? setShowPresupuesto(true)  : setShowPresupuesto(false);
            setGifLoader(false)
            getMultimediosList()
        })
      )
    }
    catch (err) {
      setGifLoader(false)
      toast.error(<span><i className="fa fa-minus-circle"></i> Existe un problema al consultar los Consumos!</span>, {position: toast.POSITION.TOP_RIGHT})
    } 
  }
  const getMultimediosList = async () => {
    setTablaMultimedios([])
    try {
      setGifLoader(true)
      const res = await getAction('/api/multimedios/' + getSelectedCliente[0].nro_cliente);
      if (!res.ok) {
        throw Error(res.statusText);
      }
      res.json()
      .then((resp => {
          // resp.data.sort((a, b) => a.nombre > b.nombre && 1 || -1)
          setTablaMultimedios(resp.data)
          setGifLoader(false)
        })
      )
    }
    catch (err) {
      setGifLoader(false)
      toast.error(<span><i className="fa fa-minus-circle"></i> Error al intentar obtener la lista de Multimedios!</span>, {position: toast.POSITION.TOP_RIGHT})
    }
  }
  const getAgregarMultimedio = async () => {
    if (getSelectedCliente.length === 0){
      toast.warning(<span><i className="fa fa-minus-circle"></i>  Debe seleccionar un cliente.</span>, {position: toast.POSITION.TOP_RIGHT})
      return false
    }
    toggle()
  }


  const columnsMultimedios = [
    {
      name: 'Nro Factibilidad',
      selector: 'id_factibilidad',
      sortable: true,
      cell: (row) => <>{row.id_factibilidad ? row.id_factibilidad : 0}</>,
      right: true,
      width: '120px'
    },
    {
      name: 'Descripción',
      selector: 'documento',
      sortable: true,
      width: '800px'
    },
    {
      cell: row =>  <ButtonGroup>
                        <Button title="Editar"     onClick={(e) => editAction(e, row)} style={{marginRight: "5px", borderRadius: "5px"}}><i className="icon-pencil fa-boton"></i></Button>
                        <Button title="Borrar"     onClick={(e) => deleteMultimedioAction(e, row)} style={{marginRight: "5px", borderRadius: "5px"}}><i className="icon-trash fa-boton"></i></Button>
                        <Button title="Visualizar" onClick={(e) => pdf_Multimedios(row)} style={{marginRight: "5px", padding:"0px 5px", borderRadius: "5px"}}><i className="icon-eye fa-boton" style={{color:'#0051ff'}}></i></Button>
                    </ButtonGroup>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];


  //Multimedios Obligatorios
    const pdf_Multimedios = (fila) => {  
      mostrarAdjunto(fila.nombre_archivo, 'Archivo Multimedio')
    }   
    const pdf_Lectura = () => {  
      mostrarAdjunto(getCI_pdf, 'Cédula de Identidad')
    }   
    const pdf_Escritura = () => {  
      mostrarAdjunto(getEscritura_pdf, 'Escritura o Compra-Venta')
    }   
    const pdf_Autorizacio = () => {  
      mostrarAdjunto(getAutorizacio_pdf, 'Autorizacion No Dueño')
    }   
    const pdf_PlanoPropiedad = () => {  
      mostrarAdjunto(getPlanoPropiedad_pdf, 'Plano de Propiedad Subdividida')
    }   
    const pdf_PlanoVivienda = () => {  
      mostrarAdjunto(getPlanoVivienda_pdf, 'Plano Vivienda mayor 120 mts')
    }   
    const pdf_Presupuesto = () => { 
      mostrarAdjunto(getPresupuesto, 'Presupuesto')
    }   

    const mostrarAdjunto = (adjunto, titulo) => {  
        if (adjunto !== null){
          setModalpdfTitle(titulo)
          setThumbs(<iframe class="w-full h-full absolute top-0 left-0" id="mapaframe" src={adjunto} height="750px" width="100%" align="center" scrolling="auto" frameBorder="0" allowtransparency="true" border="0" style={{backgroundColor: "#a1a1a1"}}/>);
          if (adjunto.split('.').pop() === 'xlsx') {
              window.open(adjunto)
          } else {
              togglepdf();
          }
        } else {
          toast.info(<span><i className="fa fa-minus-circle"></i> No se adjuntado {titulo}</span>, {position: toast.POSITION.TOP_RIGHT})
        }
    }   
    const togglepdf = () => {    
        setModalpdf(!modalpdf);
    }


  //Ingreso o Consulta
    const toggle = () => {
        setModalTitle('Agregar Multimedio');
        setId('X');
        setFactibilidad(0);
        setNomFile('');
        setFile('');
        setModal(!modal);
    }


  //Elimina
    const deleteMultimedio = async (id) => {
      try {
        const res = await deleteAction('/api/multimedio/' + id)
        if (!res.ok) {
          throw Error(res.statusText);
        }
        res.json()
        .then((resp => {
            console.log(resp.data[0])
            setTablaMultimedios(tabla_Multimedios.filter(item => item.id !== id))
            toast.success(<span><i className="fa fa-successs"></i> Registro eliminado con exito!</span>, {position: toast.POSITION.TOP_RIGHT})
          })
        )
      }
      catch (err) {
        toast.error(<span><i className="fa fa-minus-circle"></i> Error al eliminar Multimedio</span>, {position: toast.POSITION.TOP_RIGHT})
      }
    }

  //Acciones
    const editAction = (e, row) => {
      toggle();
      setId(row.id);
      setFactibilidad(row.id_factibilidad);
      setNomFile(row.documento);
      setModalTitle('Actualizar Multimedio');
    }

    const deleteMultimedioAction= (e, row) => {
      if (row.is_valido === true) {
          toast.warning(<span><i className="fa fa-minus-circle"></i> Este Tipo de Convenio se utilizó en un Socio. No se puede eliminar.</span>, {position: toast.POSITION.TOP_RIGHT})
          return
      }
      confirmAlert({
        title: 'Eliminar Multimedio',
        message: row.documento + '?',
        buttons: [
          {
            label: 'Si',
            onClick: () => {
              deleteMultimedio(row.id)
            }
          },
          {
            label: 'No'
          }
        ]
      });
    }
   

  const postUploadFile = async () => {
    let _archivo = getFile
    if (getSelectedCliente.length === 0){
      toast.warning(<span><i className="fa fa-minus-circle"></i>  Debe seleccionar un cliente.</span>, {position: toast.POSITION.TOP_RIGHT})
      return false
    }
    if (getNomFile.length === 0){
      toast.warning(<span><i className="fa fa-minus-circle"></i>  Debe ingresar una descripcion del archivo</span>, {position: toast.POSITION.TOP_RIGHT})
      return false
    }
    if (_archivo.length === 0 ){
        toast.warning(<span><i className="fa fa-minus-circle"></i> Debe seleccionar una imagen para subir.</span>, {position: toast.POSITION.TOP_RIGHT})
        return
    }
    try {
      setGifLoader(true)
      const _form = new FormData()
      _form.append('files', _archivo[0], _archivo[0].name)
      const res = await upAction('/api/open/multimedioFileUpload/' + getId + '/' + getFactibilidad + '/' + getSelectedCliente[0].nro_cliente + '/' + getNomFile, _form)
      if (!res.ok) {
        if(res.status === 422)
          res.json().then(err_resp => {})
        throw Error(res.statusText);
      }
      res.json()
      .then((resp => {
        setGifLoader(false)
        if (getId === 'X') {
            setTablaMultimedios(tabla_Multimedios => [...tabla_Multimedios, resp.data[0]])
        } else {
            let newArr = [...tabla_Multimedios]; 
            let index = tabla_Multimedios.findIndex((o) => { return o.id === getId });
            newArr[index] = resp.data[0]
            setTablaMultimedios(newArr);
        }
        toggle();
        toast.success(<span><i className="fa fa-successs"></i> Subida de Archivo con éxito.</span>, {position: toast.POSITION.TOP_RIGHT})
      }))
    }
    catch (err) {
      setGifLoader(false)
      toast.error(<span><i className="fa fa-minus-circle"></i> Error al guardar datos!</span>, {position: toast.POSITION.TOP_RIGHT})
    }
  }


  return (
    <div className="animated fadeIn">
        <ToastContainer />
        <Row>
          <Col xs="12" lg="10">
            <div className="sweet-loading">
              <Loader
                css={override}
                size={80}
                color={"#4A90E2"}
                loading={getGifLoader}
              />
            </div>
          </Col>
        </Row>

        <Col xs="12" lg="12" style={{padding: "0px"}}>
          <Card style={{boxShadow: "2px 3px 3px rgba(0, 0, 0, 0.3)", border: "1px solid rgb(225, 227, 229)"}}>
            <CardHeader bg="#63c2de" >
                Mantención de Multimedios      
            </CardHeader>  

            <CardBody style={{padding: "10px 0px 10px 20px"}}> 
              <Row>
                  <Label style={{marginLeft: "30px", marginTop: "5px" }}>Socio</Label>
                  <Col xs="11" md="4">
                    <FormGroup>
                      <AsyncTypeahead
                        id="Ruta_select"
                        multiple={false}
                        clearButton
                        highlight={true}
                        emptyLabel="No hay resultados."
                        labelKey={option => `${option.cliente_dato_basico}`}
                        onSearch={(query) => getCustomers(query.toUpperCase())}
                        options={tabla_clientes}
                        selected={getSelectedCliente}
                        onChange={(selected) => setSelectedCliente(selected)}
                        placeholder="Seleccione cliente ..."
                      />
                    </FormGroup>
                  </Col> 
                  <Col xs="11" md="3">
                      <Button title="Buscar Resultado" onClick={ getMultimedios } className="fa-buscar"><i className="fa fa-search fa-boton" aria-hidden="true"></i></Button>
                  </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>

        <Row id="_mostrarResultado">
          <Col xs="12" md="12" lg="12">
              <Row>
                <Col xs="12" lg="12">
                  <Card style={{border: "0px", backgroundColor: "transparent", margin: "0px"}}>
                    <CardBody style={{alignSelf: "center"}}>
                          <Row xs="12" lg="12">
                             <Button color="primary"  disabled={!getShowRut}          style={{marginRight: "10px"}} onClick={pdf_Lectura}    >Cédula de Identidad</Button>
                             <Button color="warning"  disabled={!getShowEscritura}    style={{marginRight: "10px"}} onClick={pdf_Escritura}  >Escritura o Compra-Venta</Button> 
                             <Button color="success"  disabled={!getShowAutorizacion} style={{marginRight: "10px"}} onClick={pdf_Autorizacio}>Autorizacion No Dueño</Button>
                             <Button color="info"     disabled={!getShowSubdividida}  style={{marginRight: "10px"}} onClick={pdf_PlanoPropiedad}>Plano de Propiedad Subdividida</Button>
                             <Button color="danger"   disabled={!getShowVivienda}     style={{marginRight: "10px"}} onClick={pdf_PlanoVivienda}>Plano Vivienda mayor 120 mts</Button>
                             <Button disabled={!getShowPresupuesto}  style={{marginRight: "10px", color: "white", background: "brown"}} onClick={pdf_Presupuesto}>Presupuesto</Button>
                          </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                  <CardBody style={{backgroundColor: "#e1e1e1", marginBottom: "10px", padding: "10px 20px 15px 20px"}}>
                    <Row>
                      <Col xs="12" lg="12">
                          <Button id="_agregar" color="primary" onClick={getAgregarMultimedio} className="btn-setting" style={{float: "right", marginBottom: "10px"}}><i className="fa fa-plus"></i> Agregar</Button>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12" lg="12">
                          <DataTable 
                              columns={columnsMultimedios}
                              data={tabla_Multimedios}
                              noHeader             
                              customStyles={customStyles}
                              highlightOnHover
                              defaultSortField="nombre"
                              pagination
                              paginationComponentOptions={paginationOptions}
                              paginationRowsPerPageOptions={[10, 15, 20, 25]}
                              persistTableHead
                          />
                      </Col>
                    </Row>
                  </CardBody>
              </Row>
          </Col>
        </Row>

        <Modal isOpen={modal} toggle={toggle} className="modal-dialog modal-dialog-centered" style={{ maxWidth: "950px"}}>
          <CardHeader className="cardHeader">
              <i className="icon-note"></i> {modalTitle}
          </CardHeader>
          <CardBody>
              <Row>
                <Label style={{margin: "5px 0px 0px 40px"}}>Factibilidad</Label>
                <Col xs="12" md="2" lg="2">
                    <Input type="number" className="form-control" onChange={(e) => { setFactibilidad(e.target.value)}} value={getFactibilidad} />
                </Col>
              </Row>
              <Row style={{marginTop: "10px"}}>
                <Label style={{margin: "5px 0px 0px 40px"}}>Descripción</Label>
                <Col xs="12" md="10" lg="10">
                    <Input type="text" className="form-control" onChange={(e) => { setNomFile(e.target.value.toUpperCase()) }} value={getNomFile} />
                </Col>
              </Row>
              <Row xs="12" md="12" lg="12" style={{marginBottom: "10px"}}>
                  <Col md="4" style={{margin: "20px 0px 0px 97px"}}>
                    <input type="file" accept="file_extension|audio/*|video/*|image/*|media_type"  onChange={(e) => setFile(e.target.files)} style={{marginLeft: "15px", width: "100%"}}/>
                  </Col>
              </Row>
          </CardBody>
          <CardFooter>
              <Button color="success" onClick={toggle} className="btn btn-setting" style={{float: "right", marginRight: "20px"}}><i className="icon-logout"></i> Volver</Button>
              <Button color="primary"  onClick={ () => { postUploadFile();}} style={{float: "right", marginRight: "20px"}}>Guardar Cambios</Button>{' '}
          </CardFooter>
        </Modal>

        <Modal isOpen={modalpdf} toggle={togglepdf} className="modal-dialog modal-lg">
            <CardHeader className="cardHeader" toggle={togglepdf}> {modalpdfTitle}</CardHeader>
          <div class="relative w-3/4">
                    {getThumbs}
          </div>
            <CardFooter>
                <Button color="success" onClick={togglepdf} className="btn btn-setting" style={{float: "right", marginBottom: "15px"}}><i className="icon-logout"></i> Volver</Button>
            </CardFooter>
        </Modal>

    </div>
  );
}


export default Dashboard;
